<script lang="ts" setup>
import { formatAmountUnit } from '@kira-dancer/nuxt-common/utils'
import { useSwiper } from '~/composables/common/use-swiper'
import { useTopDailyWinners } from '~/composables/home/use-top-daily-winners'
import { SlidersPerView } from '~/enums'
import { maskString } from '~/utils/string'
import { IMAGE_GAME_ITEM_DEFAULT } from '~/constants'

const { isMobile } = useDevice()
const { modules, SwiperSlide, Swiper } = useSwiper()
const { gameTopWinners } = useTopDailyWinners()
const { MAIN_CREDIT_UNIT } = useRuntimeConfig().public
</script>

<template>
  <div v-if="gameTopWinners?.length" id="topWinner" class="top-winner">
    <BaseSection title="Thắng lớn mỗi ngày">
      <Swiper
        :modules="modules"
        :slides-per-view="SlidersPerView.Auto"
        :space-between="isMobile ? 0 : 32"
        :autoplay="{
          delay: 1,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }"
        :speed="3000"
        :breakpoints="{
          1200: {
            slidesPerView: SlidersPerView.Medium,
            spaceBetween: 32,
          },
          1536: {
            slidesPerView: SlidersPerView.ExtraMedium,
            spaceBetween: 32,
          },
        }"
        loop
      >
        <SwiperSlide v-for="(winner, index) in gameTopWinners" :key="index">
          <div class="top-winner__slide">
            <BaseImage
              :src="winner.game_img.thumbnail.url || IMAGE_GAME_ITEM_DEFAULT"
              :image-default="IMAGE_GAME_ITEM_DEFAULT"
              :alt="`${winner.username} banner`"
              class="top-winner__image"
              width="40"
              height="54"
            />
            <div class="top-winner__info">
              <div class="top-winner__username">
                {{ maskString(winner.username) }}
                <span class="top-winner__highlight">thắng</span>
              </div>
              <div class="top-winner__amount">
                {{ formatAmountUnit(winner?.amount ?? 0, 1) }}
                {{ MAIN_CREDIT_UNIT }}
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </BaseSection>
  </div>
</template>

<style scoped lang="scss">
@import '~/assets/styles/components/desktop/home/top-daily-winner.scss';
@import '~/assets/styles/components/responsive/desktop/home/top-daily-winner.scss';
</style>
